import { subscriptionHistoryApi } from '../api'

const getSubscriptionHistory = async cpf => {
  try {
    const response = await subscriptionHistoryApi.getSubscriptionHistory(cpf)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: {
          history: responseBody.data.map(item => item.attributes),
        },
      }
    }
  } catch {
    return {
      success: false,
      payload: {
        history: [],
      },
      error: 'Não foi possível carregar o histórico de inscrições. Tente novamente.',
    }
  }
}

const getPdf = async id => {
  try {
    const response = await subscriptionHistoryApi.getPdf(id)

    const { ok, status } = response

    if (ok && status === 200) {
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      let tag = document.createElement('a')

      tag.href = url
      tag.download = `detalhes-inscricao-${id}.pdf`

      document.body.appendChild(tag)

      tag.click()
      tag.remove()
    }
  } catch (e) {
    console.error(e)
  }
}

const subscriptionHistoryService = {
  getSubscriptionHistory,
  getPdf,
}

export default subscriptionHistoryService